/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Fulfillment_InternalInputs */

const vi_delivery_fulfillment_internal = /** @type {(inputs: Delivery_Fulfillment_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xe nội bộ`)
};

/**

* @param {Delivery_Fulfillment_InternalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const delivery_fulfillment_internal = /** @type {((inputs?: Delivery_Fulfillment_InternalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Fulfillment_InternalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_delivery_fulfillment_internal(inputs)
});